import { ManageHomesitesPage } from "./ManageHomesitesPage";

export default ManageHomesitesPage;
